var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.params.value)?_c('vs-chip',{staticClass:"ag-grid-cell-chip",attrs:{"color":_vm.chipColor(_vm.params.value)}},[_c('span',{class:{'text-black': _vm.params.value === 3}},[_vm._v(_vm._s(_vm.chipText(_vm.params.value)))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }